export default "__VITE_ASSET__7fdf70e9__"